import { MinzeElement } from "minze";

// Standard form (not a popup), Work in progress.
export class TjFormWrapper extends MinzeElement {
  html = () => `
    <div class="form-wrapper">
      <div class="form-wrapper__content">
        <slot id="title" name="title"></slot>
        <slot id="content" name="content"></slot>
      </div>
    </div>
  `;
  css = () => `
    
  `;
}
